export const typeRoutes = {
	typeIndex: '/types'
} as const
